//Backend geldiğinde bu kod kaldırılacak ve api bağlanacak.
import { Injectable } from '@angular/core';
import {
  MarkerData,
  RectangleData,
} from '../../models/model-viewer/viewer.models';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  generateKey(modelUrl: string | null, type: '3d' | '2d'): string | null {
    if (!modelUrl) return null;
    const modelName = modelUrl.split('/').pop();

    // ORIGINAL FORMAT: three_markers_${modelName} for 3D
    // ORIGINAL FORMAT: three_rects_2d_${modelName} for 2D
    if (type === '3d') {
      return `three_markers_${modelName}`;
    } else {
      return `three_rects_2d_${modelName}`;
    }
  }

  saveMarkers(modelUrl: string | null, markers: MarkerData[]): void {
    const key = this.generateKey(modelUrl, '3d');
    if (!key) return;

    try {
      const serializedData = JSON.stringify(
        markers.map((m) => ({
          position: { x: m.position.x, y: m.position.y, z: m.position.z },
          note: m.note,
        }))
      );
      localStorage.setItem(key, serializedData);
      console.log('3D Markers saved to localStorage');
    } catch (error) {
      console.error('Error saving 3D markers:', error);
    }
  }

  loadMarkers(modelUrl: string | null): MarkerData[] {
    const key = this.generateKey(modelUrl, '3d');
    if (!key) return [];

    try {
      const savedData = localStorage.getItem(key);
      if (!savedData) return [];

      const parsed = JSON.parse(savedData);
      return parsed.map((data: any) => ({
        position: new THREE.Vector3(
          data.position.x,
          data.position.y,
          data.position.z
        ),
        note: data.note || '',
      }));
    } catch (error) {
      console.error('Error loading 3D markers:', error);
      return [];
    }
  }

  saveRectangles(modelUrl: string | null, rectangles: RectangleData[]): void {
    const key = this.generateKey(modelUrl, '2d');
    if (!key) return;

    try {
      localStorage.setItem(key, JSON.stringify(rectangles));
      console.log('2D Rectangles saved to localStorage');
    } catch (error) {
      console.error('Error saving 2D rectangles:', error);
    }
  }

  loadRectangles(modelUrl: string | null): RectangleData[] {
    const key = this.generateKey(modelUrl, '2d');
    if (!key) return [];

    try {
      const savedData = localStorage.getItem(key);
      return savedData ? JSON.parse(savedData) : [];
    } catch (error) {
      console.error('Error loading 2D rectangles:', error);
      return [];
    }
  }

  clearData(modelUrl: string | null): void {
    const key3d = this.generateKey(modelUrl, '3d');
    const key2d = this.generateKey(modelUrl, '2d');

    if (key3d) localStorage.removeItem(key3d);
    if (key2d) localStorage.removeItem(key2d);
  }

  clearAllData(): void {
    Object.keys(localStorage)
      .filter(
        (key) =>
          key.startsWith('three_markers_') || key.startsWith('three_rects_2d_')
      )
      .forEach((key) => localStorage.removeItem(key));
  }
}

import * as THREE from 'three';
